import { render, staticRenderFns } from "./SectionResults.vue?vue&type=template&id=b4672e56&"
import script from "./SectionResults.vue?vue&type=script&lang=js&"
export * from "./SectionResults.vue?vue&type=script&lang=js&"
import style0 from "./SectionResults.vue?vue&type=style&index=0&id=b4672e56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SectionResults.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports